import { ExperiencesState } from '../types/state';

const initialState: ExperiencesState = {};

export default function (state = initialState): ExperiencesState {
  return state;
}
